import { BaseModel } from '../../_base/crud';

export class Condition extends BaseModel {
  id: number;
  resourceType: string;
  active: boolean;
  period: JSON;
  period_start: string;
  period_end: string;
  notAvailable_description: string;
  notAvailable_during_start: string;
  notAvailable_during_end: string;
  practitioner: JSON;
  doctor_id: number;
  organization: JSON;
  specialty: any[];
  telecom: any[];
  availableTime: any[];
  notAvailable: any[];
  availabilityExceptions: string;
  healthcareService: any[];
  daysOfWeek: any;
  availableStartTime;
  availableEndTime;
  // here

  type;
  category;
  criticality;

  note;
  substance;
  manifestation;
  manifestationSeverity;
  manifestationDescription;
  manifestationOnset;
  recorderResourceType;
  recorder;
  asserterType;
  asserter;
  evidence;
  summary;

  clinicalStatus;
  verificationStatus;
  code;
  bodySite;
  severity;
  recordedDate;
  onset;
  onsetType;
  onsetDate;
  onsetString;
  onsetPeriodStart;
  onsetPeriodEnd;
  onsetAge;
  onsetAgeUnit;
  onsetRangeHigh;
  onsetRangeLow;
  abatement;
  abatementType;
  abatementDate;
  abatementString;
  abatementPeriodStart;
  abatementPeriodEnd;
  abatementAge;
  abatementAgeUnit;
  abatementRangeHigh;
  abatementRangeLow;
  stage;
  clear(): void {
    this.id = 0;
    this.resourceType = '';
    this.availabilityExceptions = '';
    this.period_start = '';
    this.period_end = '';
    this.active = false;
    this.period = null;
    this.practitioner = null;
    this.organization = null;
    this.healthcareService = [];
    this.notAvailable = [];
    this.availableTime = [];
    this.telecom = [];
    this.specialty = [];
    this.code = [];
    this.doctor_id = null;
  }
}
